export const onboardingData = [
  {
    id: '1',
    step: 1,
    code: 'importCreators',
    title: 'Switching from another tool?',
    description: '<p>You can import your list of creators into  SARAL from here.</p>',
  },
  {
    id: '2',
    step: 2,
    code: 'saralHome',
    title: '🏠 SARAL Home ',
    description:
      '<p>You can see your progress here. This is your dashboard with analytics and your mastery level.</p><br/><p>Show it off!</p>',
    navigateTo: '/dashboard',
  },
  {
    id: '3',
    step: 3,
    code: 'discovery',
    title: '🔍 Find any creator in the world',
    description:
      '<p>Our search engine searches across Instagram, TikTok, and Youtube.</p><br/><p>You can filter by follower count, engagement, gender, views, and more!</p>',
    navigateTo: '/dashboard/discovery',
  },
  {
    id: '4',
    step: 4,
    code: 'lists',
    title: '📄 Organise your creators in Lists',
    description:
      '<p>Save creators from discovery into lists.</p><br/><p>Make lists by category, size, or however you want!</p>',
    navigateTo: '/dashboard/list',
  },
  {
    id: '5',
    step: 5,
    code: 'emailDrips',
    title: '📄 Automate Outreach Emails',
    description:
      '<p>Send automated email campaigns to 100’s of influencers at once without landing in spam!</p><br /><p>Automate follow ups if they don’t reply. Their responses show up in SARAL and your inbox directly!</p>',
    navigateTo: '/dashboard/email-drips',
  },
  {
    id: '6',
    step: 6,
    code: 'relationships',
    title: '🤝 Manage Relationships',
    description:
      '<p>Manage and track your relationships here! Add tags, generate affiliate links, ship products, and more!</p>',
    navigateTo: '/dashboard/relationship',
  },
  {
    id: '7',
    step: 7,
    code: 'applications',
    title: '🙋🏻‍♂ Collect Applications from customers/followers',
    description: '<p>Create an application page and get influencers applying to promote your brand!</p>',
    navigateTo: '/dashboard/applications',
  },
  {
    id: '8',
    step: 8,
    code: 'performance',
    title: '📊 Monitor Performance',
    description: '<p>See campaign performance, track content, and more useful analytics!</p>',
    navigateTo: '/dashboard/performance',
  },
  {
    id: '9',
    step: 9,
    code: 'payments',
    title: '💰 Pay Commissions!',
    description: '<p>You can pay creators, track any manual payments, and view your payments history right here!</p>',
    navigateTo: '/dashboard/payments',
  },
  {
    id: '10',
    step: 10,
    code: 'settings',
    title: '⚙️ Settings',
    description: '<p>Set a profile picture, connect your email account, Shopify store, and more!</p>',
    navigateTo: '/dashboard/settings',
  },
  {
    id: '11',
    step: 11,
    code: 'notifications',
    title: 'Notifications',
    description:
      '<p>We will notify you about packages received, emails responded to, and tasks that are due here. </p>',
    navigateTo: '/dashboard',
  },
  {
    id: '12',
    step: 12,
    code: 'ratnaCount',
    title: 'Ratna Gems - Save Creators Flexibly',
    description:
      '<p>You get 50 Ratna as part of your trial. You get +300 every month once your subscription starts.</p><br /><p>You can save 300 influencers with these. If you need more, get a booster pack or contact us for more.</p>',
    navigateTo: '/dashboard',
  },
  {
    id: '13',
    step: 13,
    code: 'profile',
    title: 'Profile',
    description: '<p>You can access settings and log out of SARAL here. </p>',
    navigateTo: '/dashboard',
  },
];
